// src/components/ui/NavItem.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavItem = ({ children, to, className = '' }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(to)}
      className={`text-gray-300 hover:text-white transition-colors duration-300 ${className}`}
    >
      {children}
    </button>
  );
};

export default NavItem;